<script>
  import { Line } from "vue-chartjs";
  import moment from "moment";

  /**
   * @class
   * @classdesc 週次ヒヤリハット件数グラフ
   */
  const NearMissWeeklyChart = {
    extends: Line,
    props: {
      label: Array,
      toDate: moment
    },
    data() {
      return {
        chartContent: {},
        options: {
          responsive: true,
          maintainAspectRatio: false,
          title: {
            display: true,
            text: "ヒヤリハット件数"
          },
          scales: {
            yAxes: [
              {
                ticks: {
                  min: 0
                }
              }
            ]
          }
        }
      };
    },
    created() {
      // Vuexストアからグラフデータを生成する
      this.chartContent = this.$store.state.aggregations.weekly.nearMissReportList;
    },
    mounted() {
      // グラフを生成する
      this.renderChart(this.chartData, this.options);
    },
    computed: {
      /**
       * 生成のためのグラフデータを設定する
       */
      chartData() {
        if (this.chartContent !== void 0 && this.chartContent.current !== void 0 && this.chartContent.current.length > 0) {
          return {
            labels: this.label,
            datasets: [
              {
                title: "当週件数",
                label: "当週件数: " + this.chartContent.currentTotal + "件",
                borderColor: "#c00",
                fill: false,
                data: this.chartContent.current,
                tension: 0
              },
              {
                title: "前週件数",
                label: "前週件数: " + this.chartContent.prevTotal + "件",
                borderColor: "#393",
                fill: false,
                data: this.chartContent.prev,
                tension: 0
              }
            ]
          };
        }
      }
    }
  };

  export default NearMissWeeklyChart;
</script>
